import clamp from 'lodash/clamp';

function getColorType(type: string) {
  switch (type) {
    case 'ellipsis':
      return 'fill-current';
    case 'spinner':
    default:
      return 'stroke-current';
  }
}

function getStrokeWidth(size: number) {
  return clamp(10 - ((size - 24) * 4) / 24, 6, 10);
}

export { getColorType, getStrokeWidth };
